var _path, _circle, _circle2, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 79.002C61.3152 79.002 79 61.3172 79 39.5019C79 17.6867 61.3152 0.00195313 39.5 0.00195313C17.6847 0.00195313 0 17.6867 0 39.5019C0 61.3172 17.6847 79.002 39.5 79.002Z",
    fill: "#FCCC63"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 44.502,
    r: 5.5,
    fill: "#DC9BA3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 35.502,
    r: 5.5,
    fill: "#DC9BA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50.002C42 53.002 47.5 52.002 53.5 44.002",
    stroke: "#3F3D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8094 30.5539C25.8146 28.1688 23.5638 29.5602 23.4029 32.8441",
    stroke: "#3F3D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.806 26.246C47.4974 23.1919 44.9716 23.9808 44.0001 27.1218",
    stroke: "#3F3D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.66dae1a566724d8202f5fd457e5e110a.svg";
export { ForwardRef as ReactComponent };